import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 90vh;
  width: 100vw;
  position: relative;

  iframe {
    position: absolute;
    height: 100%;
    width: 100%;
  }
`
